import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import GlobalStyle from './styles/GlobalStyle';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './components/LoginPage';
import HomePage from './components/HomePage';
import SampleDetail from './components/SampleDetail';
import SampleForm from './components/SampleForm';
import SuperAdminPage from './components/SuperAdminPage';
import AdminPage from './components/AdminPage';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #f5f5f5;
`;

function App() {
  return (
    <Router>
      <AuthProvider>
        <GlobalStyle />
        <AppContainer>
          <Routes>
            {/* Public */}
            <Route path="/login" element={<LoginPage />} />

            {/* Super Admin only */}
            <Route
              path="/superadmin"
              element={
                <ProtectedRoute role="superadmin">
                  <SuperAdminPage />
                </ProtectedRoute>
              }
            />

            {/* Admin + Super Admin */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute role="tenant-admin">
                  <AdminPage />
                </ProtectedRoute>
              }
            />

            {/* App: all authenticated users */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <HomePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sample/:id"
              element={
                <ProtectedRoute>
                  <SampleDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sample/:id/edit"
              element={
                <ProtectedRoute>
                  <SampleForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/new-sample"
              element={
                <ProtectedRoute>
                  <SampleForm />
                </ProtectedRoute>
              }
            />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AppContainer>
      </AuthProvider>
    </Router>
  );
}

export default App;
